/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Grid_PInputs */

const es_gift_grid_p = /** @type {(inputs: Gift_Grid_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde el que aún confunde babor con estribor hasta el que ya manda en el pantalán. Cada tarjeta tiene su rango y su personalidad.`)
};

const gl_gift_grid_p = /** @type {(inputs: Gift_Grid_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde quen aínda confunde babor con estribor ata quen xa manda no pantalán. Cada tarxeta ten o seu rango e personalidade.`)
};

const en_gift_grid_p = /** @type {(inputs: Gift_Grid_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From mixing up port and starboard to running the pontoon — each card has its range and personality.`)
};

/**
* | output |
* | --- |
* | "From mixing up port and starboard to running the pontoon — each card has its range and personality." |
*
* @param {Gift_Grid_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_grid_p = /** @type {((inputs?: Gift_Grid_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Grid_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_grid_p(inputs)
	if (locale === "en") return en_gift_grid_p(inputs)
	return es_gift_grid_p(inputs)
});